import React, { useState } from "react";
import clsx from "clsx";
import { isEmail } from "_common/_utils/alphaNumUtils";
import { marketingStore } from "marketing/_stores/marketingStore";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export function FooterForm() {
    const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
    const { t } = useTranslation();

    return (
        <>
            <div
                className={clsx("text-lg font-semibold text-white leading-snug", "mb-5")}
                dangerouslySetInnerHTML={{ __html: t("footer.newsletterTitle") }}
            />
            <div className={"mb-5 text-base"}>{t("footer.newsletterContent")}</div>
            <input
                name="firstName"
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder={t("footer.firstName")}
                className={"w-full text-black bg-white h-11 rounded-md px-4 py-3"}
            />
            <input
                name="phone"
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder={t("footer.phone")}
                className={"w-full text-black bg-white h-11 rounded-md px-4 py-3 mt-5"}
            />
            <input
                name="email"
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder={t("footer.email")}
                className={"w-full text-black bg-white h-11 rounded-md px-4 py-3 mt-5"}
            />
            <div
                onClick={() => {
                    if (formData.email && formData.name && formData.phone && isEmail(formData.email)) {
                        marketingStore.subscribe(formData).then(
                            () => toast.success(t("footer.youVeBeenSubscribed")),
                            () => toast.error(t("footer.error")),
                        );
                    } else {
                        toast.error(t("footer.checkACFields"));
                    }
                }}
                className={
                    "bg-[color:var(--color-secondary)] rounded-lg px-10 py-2.5 text-center w-52 mt-5 cursor-pointer"
                }
            >
                {t("words.submit")}
            </div>
        </>
    );
}
